import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const ChequeStatusList: React.FC = () => {
  const navigate = useNavigate();

  // Header
  useEffect(() => {
    updateMainHeader("Cheque Managment");
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Cheque Status": "/chequestatus/list" },
  ]);

  const source = {
    url: "Vyapar/Product/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

 
  const columns: IColumns[] = [
    { header: "Cheque Number", fieldName: "chequenumber" },
    { header: "Bank Name", fieldName: "bankname" },
    { header: "Customer", fieldName: "customer" },
    { header: "Amount", fieldName: "amount" },
    { header: "Issue Date", fieldName: "issuedate" },
    { header: "Status", fieldName: "status" },
   
  ];

  // Filters (UI only)
  const filterRows: IRows[] = [
    {
      label: "Item Name",
      fieldName: "itemname",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Category",
      fieldName: "category",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Supplier Name",
      fieldName: "suppliername",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Created Date",
      fieldName: "createdAt",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
  ];

  const handleClick = () => {
    navigate("/chequestatus");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="itemMasterGrid"
            title="Cheque Status"
            headerType="modern"
            columns={columns}
            source={source}
            filterFields={filterRows}
            rowsPerPageCount={10}
            searchBox={{ searchMode:"query" }}
            addButton={{ label: "Add New Item", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};